module.exports = __webpack_public_path__ + "img/phone.5f356a6f.png";